import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { gradients } from './constants';

export const root = css`
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
`;

export const clickable = css`
  cursor: pointer;
`;

export const colors = {
  inherit: () => css`
    fill: currentColor;
  `,
  primary: () => css`
    fill: url(#${gradients.primary});
  `,
  secondary: (theme: Theme) => css`
    fill: ${theme.palette.primary.mainContrast};
  `,
  actionPrimary: () => css`
    fill: url(#${gradients.actionPrimary});
  `,
  additional: (theme: Theme) => css`
    fill: ${theme.palette.secondary.mainContrast};
  `,
  secondaryMainContrast: (theme: Theme) => css`
    fill: ${theme.palette.secondary.mainContrast};
  `,
  secondaryMaxContrast: (theme: Theme) => css`
    fill: ${theme.palette.secondary.maxContrast};
  `,
  secondaryUpperMediumContrast: (theme: Theme) => css`
    fill: ${theme.palette.secondary.upperMidContrast};
  `,
  tertiaryUpperMediumContrast: (theme: Theme) => css`
    fill: ${theme.palette.tertiary.upperMediumContrast};
  `,
  tertiaryMain: (theme: Theme) => css`
    fill: ${theme.palette.tertiary.main};
  `,
  highlight: (theme: Theme) => css`
    fill: ${theme.palette.secondary.mainContrast};
  `,
  textTitle: (theme: Theme) => css`
    fill: ${theme.palette.text.title};
  `,
  success: (theme: Theme) => css`
    fill: ${theme.palette.success.main};
  `,
  warning: (theme: Theme) => css`
    fill: ${theme.palette.warning.main};
  `,
  error: (theme: Theme) => css`
    fill: ${theme.palette.error.main};
  `,
  gray: (theme: Theme) => css`
    fill: ${theme.palette.icons.main};
  `,
  white: (theme: Theme) => css`
    fill: ${theme.palette.secondary.reversedContrast};
  `,
  disabled: (theme: Theme) => css`
    fill: ${theme.palette.disabled.accent};
  `,
};

// Icons are sized via `font-size` only. The generated SVGs carry
// width="1em" height="1em" (svgr `icon: true`), so 1em === font-size
// and the rendered icon scales with it — this also lets consumers size
// an icon by setting font-size on it / its parent. Do NOT add explicit
// px width/height here: that locks the size and breaks font-size-based
// scaling (icons render too big/too small).
export const sizes = {
  '12': css`
    font-size: 12px;
  `,
  '16': css`
    font-size: 16px;
  `,
  '18': css`
    font-size: 18px;
  `,
  '20': css`
    font-size: 20px;
  `,
  '24': css`
    font-size: 24px;
  `,
  '30': css`
    font-size: 30px;
  `,
  '32': css`
    font-size: 32px;
  `,
  '40': css`
    font-size: 40px;
  `,
  '48': css`
    font-size: 48px;
  `,
  '56': css`
    font-size: 56px;
  `,
  '80': css`
    font-size: 80px;
  `,
  '96': css`
    font-size: 96px;
  `,
  '125': css`
    font-size: 125px;
  `,
  inherit: css`
    font-size: inherit;
  `,
};
